import { Route, Switch } from 'react-router-dom';
import { OverviewPOM } from './Overview/OverviewPOM';
import { SinglePOM } from './Single/SinglePOM';
import './pom.scss';

export const POM = () => {
	return (
		<div className='POM'>
			<Switch>
				<Route path={'/pom/:pomId'}>
					<SinglePOM />
				</Route>

				<Route path='/pom'>
					<OverviewPOM />
				</Route>
			</Switch>
		</div>
	);
};
